import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {UnsubscribeOnDestroyAdapter} from '@shared';
import {DefaultResponse} from "@core/models/Http/DefaultResponse";
import {environment} from "@enviroment/environment";
import {GeneralFunctionsService} from "@core/service/generalFunctions.service";
import {UserType} from "@core/models/UserType";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";
import {MsgResponse} from "@core/models/MsgResponse";

@Injectable({
  providedIn: 'root',
})

export class UserTypeService extends UnsubscribeOnDestroyAdapter {
  isTblLoading = true;
  dataChange: BehaviorSubject<UserType[]> = new BehaviorSubject<UserType[]>([]);
  dialogData!: UserType;

  constructor(
    private httpClient: HttpClient,
    private readonly gfs: GeneralFunctionsService,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    super();

  }

  get data(): UserType[] {
    return this.dataChange.value;
  }

  getDialogData() {
    return this.dialogData;
  }

  getAllUserTypes(): void {
    this.subs.sink = this.httpClient.get<DefaultResponse<UserType[]>>(
      `${environment.backend_url}TipoUsuario`,).subscribe({
      next: (data) => {
        this.isTblLoading = false;
        this.dataChange.next(data.data);
      },
      error: (error: HttpErrorResponse) => {
        this.isTblLoading = false;
        this.httpMsgHandler.handleMsg(error);
      },
    });
  }
}
